<template>
  <section class="display-fields flex flex-col gap-4">
    <section class="flex justify-between items-center">
      <label class="label-option"> {{ $i18nPresenter.t('Collect audience info') }}</label>
      <AddParticipantFields
        :presentationId="presentation.id"
        :selectedFields="selectedParticipantFields"
        @create="handleCreateCustomField"
        @select="handleSelectCustomField"
      >
      </AddParticipantFields>
    </section>
    <section class="selected-fields">
      <SelectedParticipantFields
        :presentationId="presentation.id"
        :selectedFields="selectedParticipantFields"
        @update:selectedParticipantFields="updateSelectedFields"
      >
      </SelectedParticipantFields>
    </section>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import SelectedParticipantFields from '@/components-v2/presentation-editor/side-right/SelectedParticipantFields.vue'
import AddParticipantFields from '@/components-v2/presentation-editor/side-right/AddParticipantFields.vue'

export default {
  components: {
    AddParticipantFields,
    SelectedParticipantFields,
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters('slideSettingModule', ['selectedParticipantFields']),
    ...mapGetters('slideModule', ['slideActive']),
  },
  methods: {
    ...mapActions('slideSettingModule', ['updateSelectedParticipantFields']),
    formatToSelectedFields(field) {
      return {
        id: field.id,
        required: field.required,
        hidden: field.hidden,
      }
    },
    addToSelectedField(field) {
      this.updateSelectedParticipantFields({
        slideId: this.slideActive.id,
        fields: this.selectedParticipantFields.concat(this.formatToSelectedFields(field)),
      })
    },
    handleCreateCustomField(field) {
      this.addToSelectedField(field)
    },
    handleSelectCustomField(field) {
      this.addToSelectedField(field)
    },
    updateSelectedFields(reorderedFields) {
      this.updateSelectedParticipantFields({
        slideId: this.slideActive.id,
        fields: reorderedFields.map(this.formatToSelectedFields),
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.flex {
    display: flex;
    flex-basis: auto;
}
</style>
